<template>
  <div class="register-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="full-page operator-select-page section-image"
        filter-color="black">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-6 ml-auto mr-auto">
                <!-- operator selection -->
                <card type="lock" :footer-line="true">
                  <div class="panel-body">
                    <div v-if="loading" class="spinner-container">
                      <double-bounce size="60px"></double-bounce>
                    </div>

                    <div
                      v-if="loadingError"
                      class="alert alert-danger"
                      role="alert">
                      {{ loadingError }}
                    </div>

                    <div v-if="!loading && operators.length > 0">
                      <h2>Select an account:</h2>
                      <div class="list-group">
                        <button
                          type="button"
                          @click="selectOperator(operator)"
                          v-for="operator in operators"
                          v-bind:key="operator.id"
                          class="list-group-item list-group-item-action clickable">
                          {{ operator.name }}
                        </button>
                      </div>
                      <div class="spacer"></div>
                      <div slot="footer" class="text-muted small">
                        <p>
                          Need help? Please
                          <a href="mailto:support@cabcard.services">contact support</a>.
                        </p>
                        <div class="text-right">
                          <button
                            class="btn btn-xs btn-link"
                            v-on:click="logout">
                            <i class="fa fa-sign-out"></i>&nbsp; Log out
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p class="lead">
                        There are no accounts associated with your user information.
                      </p>
                      <p>This dashboard is intended for fleet users. Perhaps you meant to log in to the <a href="https://my.cabcard.services">CabCard driver dashboard</a>?</p>  
                      <p>
                        If you need help, please
                        <a href="mailto:support@cabcard.services">contact support</a>.
                      </p>
                      <div class="text-right">
                        <button class="btn btn-xs btn-link" v-on:click="logout">
                          <i class="fa fa-sign-out"></i>&nbsp; Log out
                        </button>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>
        <!-- <app-footer></app-footer> -->
        <div
          class="full-page-background"
          style="background: #F7971E; background: -webkit-linear-gradient(to left, #FFD200, #F7971E); background: linear-gradient(to left, #FFD200, #F7971E);">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { DoubleBounce } from "vue-loading-spinner";
import { doUntil } from "async-es";

import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import {
  Card,
  Checkbox,
  Button,
  InfoSection
} from "src/components/UIComponents";

export default {
  components: {
    Card,
    AppNavbar,
    DoubleBounce,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      form: {
        name: ""
      },
      formValidators: {
        name: {
          required: true,
          min: 3
        }
      },
      validationErrors: {},
      errorMessage: null,
      creating: false,
      loading: false,
      operators: [],
      loadingError: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    selectOperator(operator) {
      // set to local storage
      this.$store.commit("SET_OPERATOR", operator);
      // load operator user
      this.axios
        .get(`/v1/operators/${operator.id}/users/current`)
        .then(response => {
          this.$store.commit("SET_OPERATOR_USER", response.data);

          // go to operator dashboard
          this.$router.push("/dashboard");
        })
        .catch(error => {
          this.loadingError = "Failed to load operator user";
        });
    },
    fieldError(fieldName) {
      // clientside
      if (this.errors.first(fieldName)) {
        return this.errors.first(fieldName);
      }

      // serverside
      const fieldError = _.find(this.validationErrors, item => {
        return _.includes(item.field, fieldName);
      });

      if (!fieldError) {
        return false;
      } else if (fieldError.messages) {
        return fieldError.messages;
      } else {
        return true;
      }
    },
    loadAllOperators() {
      const instance = this;
      instance.loading = true;

      const limit = 100;
      let offset = 0;
      let totalAvailable;
      doUntil(
        next => {
          instance.axios
            .get("/v1/operators?sort=name", {
              headers: {
                "x-apicache-bypass": "true" // bypass API cache to get accessible operators
              },
              params: {
                offset,
                limit
              }
            })
            .then(response => {
              instance.operators = instance.operators.concat(response.data);
              totalAvailable = parseInt(response.headers["total-count"], 10);
              offset += limit;
              return next();
            })
            .catch(error => {
              return next(error);
            });
        },
        cb => {
          return cb(null, instance.operators.length >= totalAvailable);
        },
        err => {
          instance.loading = false;
          if (err) {
            instance.loadingError = "Failed to load operators";
            instance.loadingError += ` - ${err.message}`;
          }
        }
      );
    }
  },
  beforeMount() {
    this.loadAllOperators();
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style></style>
